import global from "../global.js";
//import {Message} from "../Message";

const log = global.log.getLogger("f_mtac.ui.InputAddressAutocompleteArea");
log.setLevel(log.levels.WARN);

// designed from example here: https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete

/**
 * InputAddressAutocompleteArea is responsible for:
 * - providing a modal dialog to fill an address
 * - using the Google Autocomplete API (the Places API shall be activated and the Google cloud console)
 * - send back the position (lat, lng) of the address or null
 */
let InputAddressAutocompleteArea = function () {
    var {Modal} = window.f_mtac_theme;
    var input_address_autocomplete_area_modal;

    var location = null; // the center (lng,lat) associated to the address, to be returned
    var name = ""; // the name associated to the address, to be returned and proposed as sitac name
    let language = ""; // language of the search
    let autocomplete = null; // the instance of the google autocomplete feature
    let listener_added = false; // flag to add the listener once
    var $input_address_autocomplete_area;

    // Find the language accepted by Google Autocomplete
    const find_best_language = () => {
        let lang = global.configuration.internationalization.language;
        // "en-GB", "fr-CA", ... can be used as is
        if (lang != "en-GB" && lang != "fr-CA" && lang != "pt-PT") {
            // for the others, extract xx from xx-YY
            let code = lang.split("-")[0];
            if (code !== undefined) {
                lang = code;
            }
        }
        log.debug("find_best_language", {lang});
        return lang;
    };

    /**
     * Initialisation of the google Autocomplete feature with the given language
     * @param lg the language
     */
    const init_autocomplete = (lg) => {
        log.debug("init_autocomplete", {lg});
        const input = document.getElementById("pac-input");
        const options = {
            fields: ["formatted_address", "geometry", "name"],
            strictBounds: false,
            types: ["geocode"],
            language: lg
        };
        autocomplete = new window.google.maps.places.Autocomplete(input, options);
    };

    /**
     * Starts the interaction with the InputAddressAutocompleteArea dialog
     * @returns {Promise<unknown>} location of the place [lng,lat], or null if not found or cancelled
     */
    this.interact = function () {
        $input_address_autocomplete_area = document.getElementById("input_address_autocomplete_area");
        input_address_autocomplete_area_modal = new Modal($input_address_autocomplete_area);
        location = null;

        if (window.google == undefined) {
            log.error("Google API not found");
            return null;
        }

        let lang = find_best_language();

        // init autocomplete once, and if language has changed
        if (autocomplete == null || lang != language) {
            language = lang;
            init_autocomplete(language);
        }

        // Prepare DOM elements
        $("#input_address_autocomplete_area .modal-title").text(global.internationalization.text("media.Address-to-search"));
        $("#input_address_autocomplete_area input").val(""); // empty the input field
        $("#input_address_autocomplete_area .invalid-feedback").text(global.internationalization.text("media.Address-not-found"));
        $("#input_address_autocomplete_area .invalid-feedback").hide();

        // Remove Google list items (otherwise it is displayed when coming back)
        document.querySelectorAll(".pac-item").forEach((el) => {
            el.parentNode.removeChild(el);
        });

        // User actions handlers and listeners
        let handlers = {
            ok: () => {
                input_address_autocomplete_area_modal.hide();
            },
            close: () => {
                location = null;
                name = "";
                input_address_autocomplete_area_modal.hide();
            }
        };

        // Add listener 'place_changed' fired by google Autocomplete, if not already done
        if (!listener_added) {
            autocomplete.addListener("place_changed", () => {
                const place = autocomplete.getPlace();
                log.debug("place_changed", {place});
                if (!place) {
                    return;
                }
                if (!place.geometry || !place.geometry.location) {
                    // Enter pressed on a place that was not suggested or the place details request failed.
                    location = null;
                    name = "";
                    log.debug("Invalid location");
                    $("#input_address_autocomplete_area .invalid-feedback").show();
                } else {
                    location = [place.geometry.location.lng(), place.geometry.location.lat()];
                    name = place.name;
                    log.debug("Valid location [lon, lat]", location);
                    handlers["ok"]();
                }
            });
            listener_added = true;
        }

        $input_address_autocomplete_area.addEventListener("shown.bs.modal", () => {
            $("#input_address_autocomplete_area input").trigger("focus").trigger("select");
        });

        // Call appropriate handler when clicking on [OK] or [Cancel]
        $("body").on("click.input_address_autocomplete_area.btn", "#input_address_autocomplete_area .btn", (event) => {
            let method = $(event.currentTarget).data("method");
            log.debug(`Pressed ${method} button`);
            handlers[method]();
        });

        // Callback on keyboard hit.
        $("body").on("keydown", "#pac-container input", async (event) => {
            if (event.key !== "Enter") {
                location = null;
                name = "";
                $("#input_address_autocomplete_area .invalid-feedback").hide();
            }
        });

        return new Promise((resolve) => {
            let interaction_end = () => {
                log.debug("Removing listeners");
                // Remove all listeners
                $("body").off("click.input_address_autocomplete_area.btn", "#input_address_autocomplete_area .btn");
                $("body").off("keydown", "#pac-container input");
                $input_address_autocomplete_area.removeEventListener("shown.bs.modal", () => {});
                $input_address_autocomplete_area.removeEventListener("hidden.bs.modal", interaction_end);
                $("#input_address_autocomplete_area input").off("focus blur keydown keyup paste input");

                log.debug("Interaction resolved with:", {location, name});
                resolve({location, name});
            };

            $input_address_autocomplete_area.addEventListener("hidden.bs.modal", interaction_end);
            input_address_autocomplete_area_modal.show();
        });
    };
};

export default new InputAddressAutocompleteArea();
